// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* This file contains overrodes for various browsers.
 *
 * Anything that's site wide but doesn't fit in the common.css file
 * Stuff like overriding yellow autofill garbage in chrome or
 * a fix for IE.
 * */

/* get rid of the yellow autofill crap in chrome */
input:-webkit-autofill {
  -webkit-box-shadow: 0 0 0 50px white inset; /* Change the color to your own background color */
  -webkit-text-fill-color: #333;
}

input:-webkit-autofill:focus {
  -webkit-box-shadow: 0 0 0 50px white inset;
  -webkit-text-fill-color: #333;
}

/* Everything past this point is dragons and will need to be refactored */

a,
a.md-default-theme,
a.md-default-theme:not(.md-button),
a:not(.md-button) {
  color: #505050;
  cursor: pointer;
  font-size: 16px;
  text-decoration: underline;
}

a:hover {
  color: #a1a1a1;
}

/*
    Generic errors
*/
.noResults {
  padding: 45px 0px 0px;
  text-align: center;
}

.noResults h2 {
  color: #e32b1e; /* error color */
  font-size: 32px;
  font-weight: bold;
}

/**
* Overrides
*/
.no-cursor {
  cursor: default !important;
}

.alert-danger {
  color: #000;
  font-weight: bold;
  font-size: 14px;
  margin: 1rem 0rem;
}

::-webkit-scrollbar {
  -webkit-appearance: none;
  width: 7px;
}
::-webkit-scrollbar-thumb {
  border-radius: 4px;
  background-color: rgba(0, 0, 0, 0.5);
  -webkit-box-shadow: 0 0 1px rgba(255, 255, 255, 0.5);
}

.table > thead > tr > th {
  border: none;
}

.italic {
  font-style: italic;
}
`, "",{"version":3,"sources":["webpack://./apps/lms/src/css/app.css"],"names":[],"mappings":"AAAA;;;;;IAKI;;AAEJ,kDAAkD;AAClD;EACE,0CAA0C,EAAE,kDAAkD;EAC9F,6BAA6B;AAC/B;;AAEA;EACE,0CAA0C;EAC1C,6BAA6B;AAC/B;;AAEA,yEAAyE;;AAEzE;;;;EAIE,cAAc;EACd,eAAe;EACf,eAAe;EACf,0BAA0B;AAC5B;;AAEA;EACE,cAAc;AAChB;;AAEA;;CAEC;AACD;EACE,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,cAAc,EAAE,gBAAgB;EAChC,eAAe;EACf,iBAAiB;AACnB;;AAEA;;CAEC;AACD;EACE,0BAA0B;AAC5B;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,wBAAwB;EACxB,UAAU;AACZ;AACA;EACE,kBAAkB;EAClB,oCAAoC;EACpC,oDAAoD;AACtD;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,kBAAkB;AACpB","sourcesContent":["/* This file contains overrodes for various browsers.\n *\n * Anything that's site wide but doesn't fit in the common.css file\n * Stuff like overriding yellow autofill garbage in chrome or\n * a fix for IE.\n * */\n\n/* get rid of the yellow autofill crap in chrome */\ninput:-webkit-autofill {\n  -webkit-box-shadow: 0 0 0 50px white inset; /* Change the color to your own background color */\n  -webkit-text-fill-color: #333;\n}\n\ninput:-webkit-autofill:focus {\n  -webkit-box-shadow: 0 0 0 50px white inset;\n  -webkit-text-fill-color: #333;\n}\n\n/* Everything past this point is dragons and will need to be refactored */\n\na,\na.md-default-theme,\na.md-default-theme:not(.md-button),\na:not(.md-button) {\n  color: #505050;\n  cursor: pointer;\n  font-size: 16px;\n  text-decoration: underline;\n}\n\na:hover {\n  color: #a1a1a1;\n}\n\n/*\n    Generic errors\n*/\n.noResults {\n  padding: 45px 0px 0px;\n  text-align: center;\n}\n\n.noResults h2 {\n  color: #e32b1e; /* error color */\n  font-size: 32px;\n  font-weight: bold;\n}\n\n/**\n* Overrides\n*/\n.no-cursor {\n  cursor: default !important;\n}\n\n.alert-danger {\n  color: #000;\n  font-weight: bold;\n  font-size: 14px;\n  margin: 1rem 0rem;\n}\n\n::-webkit-scrollbar {\n  -webkit-appearance: none;\n  width: 7px;\n}\n::-webkit-scrollbar-thumb {\n  border-radius: 4px;\n  background-color: rgba(0, 0, 0, 0.5);\n  -webkit-box-shadow: 0 0 1px rgba(255, 255, 255, 0.5);\n}\n\n.table > thead > tr > th {\n  border: none;\n}\n\n.italic {\n  font-style: italic;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
